import styled, { keyframes } from 'styled-components'
import { fadeIn, slideInFromLeft, slideInFromRight } from '../../styles/Animations'

const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
`;

export const HeroImageContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 60dvh;
  width: 100%;
  animation: ${fadeIn} 1s ease-out;

  @media (max-width: 550px) {
    /* Phones */
    grid-template-columns: 1fr;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    grid-template-columns: 1fr;
  }
`

export const HeroSectionOne = styled.div`
  background-color: #FFFFFF;
  padding-top: 11em;
  display: flex;
  flex-direction: column;
  animation: ${slideInFromLeft} 1s ease-out;

  h1{
    color: #EA0B2A;
    font-size: 6em;
    text-transform: uppercase;
    padding-left: 100px;
    animation: ${fadeIn} 1.5s ease-out;

    @media (max-width: 550px) {
      /* Phones */
      padding-left: 20px;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      padding-left: 20px;
    }
  }

  p{
    color: #282C34;
    font-size: 1.2em;
    max-width: 500px;
    min-width: 500px;
    padding-left: 100px;

    @media (max-width: 550px) {
      /* Phones */
      max-width: 300px;
      min-width: 300px;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      padding-left: 20px;
    }
  }

  img{
    position: relative;
    width: 16em;
    height: auto;
    margin-top: -290px;
    align-self: end; 
  }
`

export const HeroSectionTwo = styled.div`
  background-color: #282C34;
  padding-top: 11em;
  display: flex;
  flex-direction: column;
  animation: ${slideInFromRight} 1s ease-out;

  h1{
    color: #FFFFFF;
    font-size: 6em;
    text-transform: uppercase;
    padding-left: 170px;
    animation: ${fadeIn} 1.5s ease-out;
  }

  p{
    color: #CCCCCC;
    font-size: 1.2em;
    max-width: 500px;
    min-width: 500px;
    padding-left: 170px;
  }

  img{
    position: relative;
    width: 16em;
    height: auto;
    margin-top: -290px;
    align-self: start;
    
    @media (min-width: 1081px) {
      bottom: -1.5em;
    }
  }

  button{
    opacity: 0;
  }

  @media (max-width: 550px) {
    /* Phones */
    display: none;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    display: none;
  }
`

export const Button = styled.button`
  margin-left: 100px;
  width: 200px;
  margin-top: 20px;
  background-color: white;
  border: 1px solid #EA0B2A;
  color: #EA0B2A;
  border-radius: 30px;
  padding: 12px 52px 12px 52px;
  transition: all 0.3s ease-in-out;
  animation: ${fadeIn} 2s ease-out;

  &:hover {
    background-color: #EA0B2A;
    color: white;
    transform: scale(1.05);
  }

  @media (max-width: 550px) {
    /* Phones */
    margin-left: 20px;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    margin-left: 20px;
  }
`

export const ImageSection = styled.div`
  position: absolute;
  top: 50%;
  width: 70%;
`
